<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
            ref="previewEl"
            :src="data.fotoBase64"
            :text="avatarText(data.nama)"
            :variant="`light-primary`"
            size="90px"
            rounded
        />
      </template>
      <div class="d-flex flex-wrap">
        <b-button
            variant="primary"
            @click="$refs.refInputEl.click()"
        >
          <input
              ref="refInputEl"
              type="file"
              class="d-none"
              @input="inputImageRenderer"
          >
          <span class="d-none d-sm-inline">Ganti Foto</span>
          <feather-icon
              icon="EditIcon"
              class="d-inline d-sm-none"
          />
        </b-button>
        <b-button
            variant="outline-secondary"
            class="ml-1"
            @click="removePhoto"
        >
          <span class="d-none d-sm-inline">Hapus Foto</span>
          <feather-icon
              icon="TrashIcon"
              class="d-inline d-sm-none"
          />
        </b-button>
        <div>
          <b-card-text>Hanya di diperbolehkan foto berupa Jpeg, Jpg dan PNG</b-card-text>
        </div>
      </div>
    </b-media>

    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <!-- Field: Username -->
        <b-col
            cols="12"
            md="4"
        >
          <!-- NIP -->
          <validation-provider
              #default="validationContext"
              name="Nip"
              rules="required"
          >
            <b-form-group
                label="NIP"
                label-for="nip"
            >
              <b-form-input
                  id="nip"
                  v-model="data.nip"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  :disabled="true"
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Field: Name -->
        <b-col
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Nama Pegawai"
              rules="required"
          >
            <b-form-group
                label="Nama Pengawas"
                label-for="nama"
            >
              <b-form-input
                  id="nama"
                  v-model="data.nama"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Field: Email -->
        <b-col
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Email"
              rules="required|email"
          >
            <b-form-group
                label="Email"
                label-for="email"
            >
              <b-form-input
                  id="email"
                  v-model="data.email"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Field: Telepon -->
        <b-col
            cols="12"
            md="4"
        >
          <!-- Telepon -->
          <validation-provider
              #default="validationContext"
              name="Telepon"
              rules="required"
          >
            <b-form-group
                label="Telepon"
                label-for="telepon"
            >
              <b-form-input
                  id="telepon"
                  v-model="data.telepon"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Field: Tanggal Lahir -->
        <b-col
            cols="12"
            md="4"
        >
          <!-- Tanggal Lahir -->
          <validation-provider
              #default="validationContext"
              name="Nip"
              rules="required"
          >
            <b-form-group
                label="Tanggal Lahir"
                label-for="tanggal_lahir">
              <flat-pickr
                  id="tanggal_lahir"
                  v-model="data.tanggal_lahir"
                  class="form-control"
                  :config="{enableTime: false}"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Bidang -->
        <b-col
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Bidang"
              rules=""
          >
            <b-form-group
                label="Bidang"
                label-for="bidang"
                :state="getValidationState(validationContext)"
            >
              <v-select
                  v-model="data.bidang"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="bidangOptions"
                  :reduce="val => val.value"
                  :clearable="true"
                  input-id="bidang"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>


        <!-- Field: Jabatan -->
        <b-col
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Jabatan"
              rules="required"
          >
            <b-form-group
                label="Jabatan"
                label-for="jabatan"
            >
              <b-form-input
                  id="jabatan"
                  v-model="data.jabatan"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Field: Kategori -->


        <b-col
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Pengawas"
              rules="required"
          >
            <b-form-group
                label="Pengawas"
                label-for="kategori"
                :state="getValidationState(validationContext)"
            >
              <b-form-input
                  id="jabatan"
                  v-model="data.pengawas.nama"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  :disabled="true"
                  placeholder=""
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
            cols="12"
            md="5"
        >
          <validation-provider
              #default="validationContext"
              name="Unit Kerja"
              rules="required"
          >
            <b-form-group
                label="Unit Kerja"
                label-for="kategori"
                :state="getValidationState(validationContext)"
            >
              <b-form-input
                  id="jabatan"
                  v-model="data.unit_kerja_place.nama"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  :disabled="true"
                  placeholder=""
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
            v-if="isChangePassword"
            cols="12"
            md="4"
        >
          <validation-provider
              #default="validationContext"
              name="Password"
              rules="required"
          >
            <b-form-group
                label="Password Baru"
                label-for="password"
            >
              <b-input-group
                  class="input-group-merge"
              >
                <b-form-input
                    id="password"
                    v-model="data.password"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder=""
                    :type="passwordFieldType"
                    class="form-control-merge"
                />
                <b-input-group-append is-text>
                  <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
            cols="12"
            md="3"
            class="my-auto"
        >
          <b-form-checkbox
              v-model="isChangePassword"
              :value="true"
              class="custom-control-primary mb-2"
          >
            Rubah Password
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-form>


    <!-- Action Buttons -->
    <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        @click.prevent="submit"
    >
      Simpan
    </b-button>
    <b-button
        variant="outline-secondary"
        type="button"
        @click="resetAll"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormInvalidFeedback,
  BCardText, BInputGroupAppend,
    BInputGroup
} from 'bootstrap-vue'
import {avatarText} from '@core/utils/filter'
import vSelect from 'vue-select'
import {useInputImageRenderer} from '@core/comp-functions/forms/form-utils'
import {ref} from '@vue/composition-api'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required, alphaNum, email} from '@validations'
import formValidation from "@core/comp-functions/forms/form-validation";
import store from "@/store";
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import {togglePasswordVisibility} from '@core/mixins/ui/forms'

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BInputGroup,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BInputGroupAppend,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BCardText,
    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  props: {
    userData: {
      type: Object,
      required: true,
    },
    bidangOptions: {
      type: Array,
      required: true
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {},
  data() {
    return {
      isChangePassword: false,
      unitKerjaOptions: []
    }
  },
  setup(props) {
    const blankData = {
      id: props.userData.id,
      nama: props.userData.nama,
      nip: props.userData.nip,
      password: null,
      telepon: props.userData.telepon,
      tanggal_lahir: props.userData.tanggal_lahir,
      jabatan: props.userData.jabatan,
      pengawas: props.userData.pengawas,
      unit_kerja: props.userData.unit_kerja_id,
      unit_kerja_place: props.userData.unit_kerja,
      foto: null,
      fotoBase64: props.userData.picture,
      bidang: props.userData.bidang_id,
      email: props.userData.email,
    }

    const data = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      data.value = JSON.parse(JSON.stringify(blankData))
    }

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const {inputImageRenderer} = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      data.value.fotoBase64 = base64
    })

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      data,
      avatarText,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      refFormObserver,
      getValidationState,
      resetForm,
      blankData,
      resetData
    }
  },
  methods: {
    resetAll() {
      this.data = JSON.parse(JSON.stringify(this.blankData))
      let that = this
      that.init = true
      this.$refs.refInputEl.value = null
      if (that.pengawas) {
        let idPengawas = this.pengawas.id;
        let that = this
        that.pengawasOptions.forEach(function (item, index) {
          if (item.value.id === idPengawas) {
            that.data.pengawas = item.value
          }
        })
      }
      if (this.userData.unit_kerja_id) {
        this.unitKerjaOptions.forEach(function (item, index) {
          if (item.value.id === that.userData.unit_kerja_id) {
            that.data.unit_kerja = item.value
          }
        })
      }
    },
    removePhoto() {
      this.$refs.refInputEl.value = null
      this.data.fotoBase64 = null
    },
    submit() {
      this.$swal({
        title: 'Apa anda yakin akan memperbaharui data?',
        text: "Data profil akan dipaharui!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, perbaharui!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-profil/update', this.data)
              .then(() => {
                this.$swal({
                  icon: 'success',
                  title: 'Berhasil!',
                  text: 'Data berhasil di perbaharui.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.$router.push({name: 'home'})
                })
              })
        }
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
